module.exports = __webpack_public_path__ + "img/20.f22253a4.png";